const ticketSettingsLinks: any[] = [
  {
    label: "MENU.CATEGORIES_SUPPORT_REQUEST",
    capability: "show_menu_categories_ticket",
    url: "/dashboard/ticket/categories-list",
    section: "lists", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
];
export default ticketSettingsLinks;
